import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid2, Box, Tab, useMediaQuery, Divider, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { processingTypes } from "../../constants/searchpageTexts";
import { useSearchQuery } from "../../hooks/useSearch/useSearchQuery";
import SearchInfoCard from "../../layouts/searchpage/SearchInfoCard";


const StyledTab = styled(Tab)({
  backgroundColor: "#fff",
  minHeight: "unset",
  "&.Mui-selected": {
    color: "#468ECD",
    border: "1px solid #468ECD",
    borderRadius: "25px",
  },
  "&:hover": {
    backgroundColor: "#eee",
    borderRadius: "25px",
  },
});


export const PopularAndNewSection = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isMobile = useMediaQuery('(max-width:600px)');

  const { data: coffeeInfoData, error } = useSearchQuery({
      keyword: "",
      categoryKey: undefined,
      categoryValue: undefined,
      pageType: "searchPage",
  }, {
      queryKey: ["green-beans", {}],
      enabled: true,
  });
  const [ listData, setListData ] = React.useState({count: 0, record: [], displaySize: isMobile ? 4 : 12 });

  const handleDetailClick = (coffee_key_id) => {
    navigate(`/detail/${coffee_key_id}`);
  };

  const LoadData = () => {
    let arr = [];
    let startValue = listData?.record?.length < 1 ? 0 : listData?.record?.length;
    if(startValue > 0) arr = listData.record;

    if (coffeeInfoData && coffeeInfoData.length > 0 && listData.record.length <= coffeeInfoData.length) {
        for(let i = startValue; i < startValue + listData.displaySize; i++) {
          if(coffeeInfoData.length === i) break;
          arr.push(coffeeInfoData[i]);
        }
        setListData({...listData, count: arr.length, record: arr});
    }
  }
  
  React.useEffect(() => {
    setListData({count: 0, record: [], displaySize: isMobile ? 4 : 12});
    LoadData();
  }, [coffeeInfoData, error]);

  
  return (
    <Box>
      <Grid2 container spacing={4}>
        <CoffeeCardList listData={listData.record} handleDetailClick={handleDetailClick} />
      </Grid2>

      &nbsp;
      <Divider sx={{ my: 2, m: 2, borderStyle: "dotted" }} />
      <Button onClick={LoadData} fullWidth ><Typography variant="h6">{t('button.more')} {i18n.language.toLowerCase() === 'ko' ? '(More)' : null}</Typography></Button>
      &nbsp;
    </Box>
  );
};

export const CoffeeCardList = (props) => {
  const { listData, handleDetailClick} = props;


  return (
    <>
    {listData && listData.length > 0 && listData.map((coffee, index) => (
        // 사용안함
        // <PopularAndNewCard
        //   key={index}
        //   dataImageUrl={coffee.ImageUrl}
        //   dataTitle={coffee.CoffeeCode}
        //   dataBeanVariety={coffee.BeanVariety.split(", ")}
        //   dataProductionCountry={coffee.ProductionCountryCode}
        //   dataCompanyName={coffee.Company}
        //   dataFarmName={coffee.Farm}
        //   dataProductionYear={coffee.ProductionYear}
        //   dataProcessingMethod={coffee.ProcessingCode}
        // />
        <SearchInfoCard
          index={index}
          handleDetailClick={() => handleDetailClick(coffee.CoffeeKey)}
          key={index+coffee.CoffeeKey}
          dataImageUrl={
            coffee.ImageUrl ||
            "https://media.istockphoto.com/id/2164909312/ko/%EC%82%AC%EC%A7%84/%EC%BB%A4%ED%94%BC-%EC%9B%90%EB%91%90-%EB%A1%9C%EC%8A%A4%ED%8C%85-%EC%A0%9C%ED%92%88-%EC%88%98%EC%B6%9C-%EB%98%90%EB%8A%94-%ED%92%88%EC%A7%88-%EB%B3%B4%EC%A6%9D%EC%9D%84-%EC%9C%84%ED%95%9C-%EC%84%B1%EB%B6%84%EC%9D%B4-%EC%9E%88%EB%8A%94-%EA%B8%B0%EA%B3%84-%EB%B0%8F-%EA%B3%B5%EC%9E%A5-%EB%B9%84%EC%96%B4-%EC%9E%88%EB%8A%94-%ED%8F%89%EB%A9%B4%EB%8F%84-%EB%B0%8F-%ED%94%84%EB%A6%AC%EB%AF%B8%EC%97%84-%EC%97%90%EC%8A%A4%ED%94%84%EB%A0%88%EC%86%8C-%EC%B9%B4%ED%8E%98%EC%9D%B8-%EB%98%90%EB%8A%94-%EC%8B%A0%EC%84%A0%ED%95%9C-%EB%B8%94%EB%A0%8C%EB%93%9C%EB%A5%BC-%EC%9C%84%ED%95%9C-%EC%9E%A5%EB%B9%84%EB%A1%9C-%EC%A0%9C%EC%A1%B0.jpg?s=1024x1024&w=is&k=20&c=U4mS4xAItRN1ml8zvDRJ1becEN0UEoA0KbnVLqENKdA="
          }
          dataTitle={coffee.CoffeeName}
          dataBeanVariety={coffee.BeanVariety.split(", ")}
          dataProductionCountry={coffee.CountryNameEng}
          dataCompanyName={coffee.Company}
          dataFarmName={coffee.Farm}
          dataProductionYear={coffee.ProductionYear}
          dataProcessingMethod={processingTypes[coffee.ProcessingCode]}
        />
      ))}
    </>
  );
};
